module.exports = __webpack_public_path__ + "img/stedin_gasnetwerk.ef56f7e2.png";